import React, { useCallback, useEffect, useState } from 'react';
import { Header } from './components/Header';
import { Hero } from './components/Hero';
import { BenefitsSection } from './components/BenefitsSection';
import { ControlSection } from './components/ControlSection';
import { HowItWorks } from './components/HowItWorks';
import { TechnologySection } from './components/TechnologySection';
import { CredibilitySection } from './components/CredibilitySection';
import { LeadFormSection } from './components/LeadFormSection';
import { FAQSection } from './components/FAQSection';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { StickyMobileCTA } from './components/StickyMobileCTA';
import { BookingModal } from './components/BookingModal';
import { heroVersions } from './data/heroVersions';
import { useScrollDepth } from './hooks/useScrollDepth';
import { scrollToId } from './utils/scroll';
import { track } from './utils/tracking';
import { initMetaPixel } from './utils/metaPixel';
import { initClarity } from './utils/clarity';

/** Meta ad angle: A = independence, B = AI and follow-up, C = marketing, D = systems and support. */
type AdVersion = 'A' | 'B' | 'C' | 'D';
interface AppProps {
  adVersion?: AdVersion;
  showStickyMobileCta?: boolean;
}
export function App({
  adVersion = 'A',
  showStickyMobileCta = true
}: AppProps) {
  const [bookingOpen, setBookingOpen] = useState(false);
  const copy = heroVersions[adVersion];
  useScrollDepth();
  useEffect(() => {
    initMetaPixel();
    initClarity();
    track('landing_page_view', {
      ad_version: adVersion
    });
  }, [adVersion]);
  const onFormCta = useCallback((source: string) => {
    if (source.startsWith('hero')) {
      track('hero_cta_click', {
        source
      });
    }
    scrollToId('lead-form');
  }, []);
  const onBookCall = useCallback((source: string) => {
    track('calendar_click', {
      source
    });
    setBookingOpen(true);
  }, []);
  return <div className="w-full bg-white pb-[68px] md:pb-0" data-id="element-0" data-mp="stcc2fmhxkt6">
      <Header onFormCta={onFormCta} data-id="element-1" data-mp="36861i5q6iv0" />

      <main data-id="element-2" data-mp="356r32ll9c80">
        <Hero copy={copy} onFormCta={onFormCta} data-id="element-3" data-mp="34napqbl6vw3" />
        <BenefitsSection onFormCta={onFormCta} data-id="element-4" data-mp="3udavo55x0h34" />
        <ControlSection onFormCta={onFormCta} data-id="element-5" data-mp="3ucjcxuxf2du9" />
        <HowItWorks data-id="element-6" data-mp="d57g95652mk4" />
        <TechnologySection onFormCta={onFormCta} data-id="element-7" data-mp="d3mn9jzh3bod" />
        <CredibilitySection data-id="element-8" data-mp="d2bhjemgvtum" />
        <LeadFormSection data-id="element-9" data-mp="851n1kk80rzx" />
        <FAQSection data-id="element-10" data-mp="86w4uq0743zs" />
        <FinalCTA onFormCta={onFormCta} data-id="element-11" data-mp="86cqtkdo1zr1" />
      </main>

      <Footer data-id="element-12" data-mp="3gklb8561bk84" />

      {showStickyMobileCta && <StickyMobileCTA onFormCta={onFormCta} onBookCall={onBookCall} data-id="element-13" data-mp="3glnym345f4ja" />}
      <BookingModal open={bookingOpen} onClose={() => setBookingOpen(false)} data-id="element-14" data-mp="3bnct24kvzg6v" />
    </div>;
}